module.exports = __webpack_public_path__ + "static/media/plan.ab5e1069.png";